import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'

import { NonProfitDetailListItem } from '../nonProfitDetailListItem/NonProfitDetailListItem'
import { FlagBadge } from '../flagBadge/FlagBadge'
import { SubTagModalFormValues } from '../dialogs/subTagsModal/SubTagsModal.types'

import { ReactComponent as PencilSVG } from '@percent/admin-dashboard/common/assets/images/pencil.svg'
import { ListItemButton } from '@percent/admin-dashboard/common/components/listItemButton/ListItemButton'
import { DecoratedActivitySubTag } from '@percent/admin-dashboard/common/hooks/useActivityTags/useActivityTags.types'
import { Badge, Spacer } from '@percent/lemonade'

type EligibilityTagsSectionProps = {
  subTagsForm: FormikProps<SubTagModalFormValues>
  subTags: DecoratedActivitySubTag[]
  inputsEditable: boolean
  insufficientSubTagsInformation: boolean
  setIsSubTagsModalOpened: (open: boolean) => void
}

export function EligibilityTagsSection({
  subTagsForm,
  subTags,
  inputsEditable,
  insufficientSubTagsInformation,
  setIsSubTagsModalOpened
}: EligibilityTagsSectionProps) {
  const { t } = useTranslation()

  return (
    <NonProfitDetailListItem title={t('table.eligibilityTags')}>
      {insufficientSubTagsInformation && <span>{t('typography.insufficientInformation')}</span>}
      {subTagsForm.values.notEducation && (
        <span>{t(inputsEditable ? 'typography.noValidSubtags' : 'typography.markedAsNoValidSubTags')}</span>
      )}
      {subTagsForm.values.subTags?.map(subTag => (
        <>
          <Badge variant="default" icon="categories">
            {(subTags as Array<DecoratedActivitySubTag>).find(({ id: subTagId }) => subTag === subTagId)?.name}
          </Badge>
          <Spacer size={2} />
        </>
      ))}
      {inputsEditable && (
        <>
          {!subTagsForm.values.insufficientInformation &&
            !subTagsForm.values.notEducation &&
            !subTagsForm.values.subTags.length && (
              <FlagBadge variant="warning">{t('typography.eligibilityReviewRequired')}</FlagBadge>
            )}

          <ListItemButton
            title={t(`button.addTags`)}
            onClick={() => setIsSubTagsModalOpened(true)}
            icon={<PencilSVG />}
          />
        </>
      )}
    </NonProfitDetailListItem>
  )
}
